// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2k3bn","amount":"Amount_amount__2qr0v","tip":"Amount_tip__YXn8r","tipHeader":"Amount_tipHeader__102GP","tipsWrap":"Amount_tipsWrap__2Tik9"};